import * as React from 'react';
import _ from 'lodash';

import { Icon, MessageBar, MessageBarType, Persona, PersonaSize, Spinner, Stack } from '@fluentui/react';
import { Breakdown, ProviderBreakdown } from '../../redux/providers/types';

import { HealAPI } from '../../healApi';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/types';

interface Props {
  visitCode: string;
}

interface Item extends ProviderBreakdown {
  fullName: string;
  avatarUrl: string;
}

export const EtaScoreBreakdown = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [breakdown, setBreakdown] = useState<Item[]>();

  const providers = useSelector((state: RootState) => state.providers.allProviders.data || []);

  useEffect(() => {
    setLoading(true);
    HealAPI.fetchEtaScoreBreakdown(props.visitCode).then((response) => {
      if (response.ok) {
        const data: Item[] = (response.data as Item[]) || [];
        data.forEach((b) => {
          const provider = providers.find((p) => p.id === b.providerId);
          if (provider) {
            b.fullName = provider.fullName;
            b.avatarUrl = provider.avatarUrl;
          }
        });
        setBreakdown(data);
      }
      setLoading(false);
    });
  }, [props.visitCode, providers]);

  if (loading) {
    return <Spinner style={{ padding: 60 }} />;
  }

  if (!breakdown) {
    return <MessageBar messageBarType={MessageBarType.info}>Unable to retrieve break-down information.</MessageBar>;
  }

  const min = _.min(breakdown.map((b) => b.score));

  return (
    <Stack style={{ padding: 20 }} tokens={{ childrenGap: 20 }}>
      {breakdown.map((b) => (
        <div key={b.providerId} style={{ padding: 10 }} className="ms-depth-4">
          <div className="flex flex-center justify-space-between" style={{ marginBottom: 10 }}>
            <Icon iconName="Accept" style={{ marginRight: 8, fontSize: 24, color: 'green', visibility: b.score === min ? 'visible' : 'hidden' }} />
            <Persona size={PersonaSize.size24} text={b.fullName} imageUrl={b.avatarUrl} />
            {b.score.toFixed()}
          </div>
          {_.keys(b.breakdown).map((k, i) => (
            <div className="flex justify-space-between" key={i}>
              <div>{k}</div>
              <div>{b.breakdown[k as keyof Breakdown].toFixed()}</div>
            </div>
          ))}
        </div>
      ))}
    </Stack>
  );
};
